/**
 * React Query hook that fetches
 * `GET /organizations/{orgId}/compliance-report?period={day|week}`.
 *
 * Kept colocated with the Compliance page because it is the only caller
 * — unlike the shared hooks in /hooks which back multiple surfaces.
 */
import { useQuery } from '@tanstack/react-query'
import { api } from '@/services'
import type { ComplianceReport, CompliancePeriod } from '@/types'

export function complianceReportQueryKey(orgId: string, period: CompliancePeriod) {
  return ['compliance-report', { orgId, period }] as const
}

export function useComplianceReport(orgId: string, period: CompliancePeriod) {
  return useQuery<ComplianceReport>({
    queryKey: complianceReportQueryKey(orgId, period),
    enabled: !!orgId,
    queryFn: () =>
      api.get<ComplianceReport>(
        `/organizations/${encodeURIComponent(orgId)}/compliance-report?period=${encodeURIComponent(period)}`
      ),
  })
}
